'use client';

import { c as _c } from "react/compiler-runtime";
import { diasAteVencimento, situacaoValidade } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
import { Badge } from '@/shared/components/ui/common/Badge';
import { formatDataPrazo } from '@/shared/formatters';
interface DocumentoPadraoSituacaoProps {
  validoAte: string | null;
  referencia: string;
  /** Janela de aviso vinda do SERVIDOR. Ausente = fallback do cliente, só até a 1ª resposta chegar. */
  diasAviso?: number;
}
export function DocumentoPadraoSituacao(t0) {
  const $ = _c(14);
  const {
    validoAte,
    referencia,
    diasAviso
  } = t0;
  const situacao = situacaoValidade(validoAte, referencia, diasAviso);
  let t1;
  if ($[0] !== referencia || $[1] !== validoAte) {
    t1 = diasAteVencimento(validoAte, referencia);
    $[0] = referencia;
    $[1] = validoAte;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dias = t1;
  if (situacao === "SEM_VALIDADE") {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="text-body font-body text-subtext-color">Não expira</span>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (situacao === "VENCIDA") {
    let t2;
    if ($[4] !== validoAte) {
      t2 = formatDataPrazo(validoAte);
      $[4] = validoAte;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const t3 = `Vencida em ${t2}`;
    let t4;
    if ($[6] !== t3) {
      t4 = <Badge variant="error">{t3}</Badge>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (situacao === "VENCENDO") {
    const t2 = dias === 0 ? "Vence hoje" : `Vence em ${dias} ${dias === 1 ? "dia" : "dias"}`;
    let t3;
    if ($[8] !== t2) {
      t3 = <Badge variant="warning">{t2}</Badge>;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t2;
  if ($[10] !== validoAte) {
    t2 = formatDataPrazo(validoAte);
    $[10] = validoAte;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = `Válido até ${t2}`;
  let t4;
  if ($[12] !== t3) {
    t4 = <span className="text-body font-body text-default-font">{t3}</span>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}